import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Gamepad2 } from "lucide-react";
import api from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";
const mediaUrl = (u) => (u ? (u.startsWith("http") ? u : `${BACKEND}${u}`) : null);

const hexA = (hex, a) => {
  const h = (hex || "#10b981").replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
};
const THEMES = {
  midnight: { bg: "#07070b", accent: "#10b981" }, ember: { bg: "#120806", accent: "#f97316" },
  ocean: { bg: "#050b12", accent: "#06b6d4" }, forest: { bg: "#07110a", accent: "#65a30d" },
  candy: { bg: "#120613", accent: "#db2777" }, royal: { bg: "#0a0716", accent: "#7c3aed" },
};

export default function EmbedStore() {
  const { slug } = useParams();
  const [k, setK] = useState(null);
  const [event, setEvent] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/gtm/store/${slug}`).then((r) => setK(r.data)).catch(() => setErr(true));
  }, [slug]);
  useEffect(() => {
    if (k?.theme === "seasonal") api.get("/events/active").then((r) => setEvent(r.data?.active ? r.data : null)).catch(() => {});
  }, [k]);

  if (err) return <div style={{ background: "#07070b", color: "#fff", fontFamily: "system-ui", padding: 16, minHeight: "100vh", display: "grid", placeItems: "center" }}>Store page unavailable.</div>;
  if (!k) return <div style={{ background: "#07070b", minHeight: "100vh" }} />;

  const base = THEMES[k.theme] || THEMES.midnight;
  const accent = (k.theme === "seasonal" && event?.accent) ? event.accent : base.accent;
  const bg = k.theme === "seasonal" ? "#0a0a10" : base.bg;
  const playUrl = k.game_id ? `${ORIGIN}/g/${k.game_id}` : `${ORIGIN}/store/${slug}`;

  return (
    <div data-testid="embed-store" className="text-white" style={{ background: `radial-gradient(600px 200px at 50% -20%, ${hexA(accent, 0.22)}, transparent), ${bg}`, minHeight: "100vh" }}>
      <div className="flex items-center gap-3 p-4" style={{ minHeight: 120 }}>
        {k.icon_url && <img src={mediaUrl(k.icon_url)} alt="" className="w-16 h-16 rounded-2xl object-cover shadow-lg shrink-0" />}
        <div className="min-w-0 flex-1">
          <p className="font-bold text-base leading-tight truncate" data-testid="embed-title">{k.game_title}</p>
          {k.tagline && <p className="text-xs text-white/70 leading-snug line-clamp-2 mt-0.5">{k.tagline}</p>}
          <div className="flex items-center gap-2 mt-2">
            <a href={playUrl} target="_blank" rel="noopener noreferrer" data-testid="embed-play-btn"
              className="inline-flex items-center gap-1.5 rounded-full text-white text-xs font-bold px-3 py-1.5 hover:opacity-90" style={{ backgroundColor: accent }}>
              <Gamepad2 className="w-3.5 h-3.5" /> Play now
            </a>
            <a href={`${ORIGIN}/store/${slug}`} target="_blank" rel="noopener noreferrer" className="text-[10px] text-white/40 hover:text-white/70">Made with GameView Studio</a>
          </div>
        </div>
      </div>
    </div>
  );
}
